import { IconButton } from '@material-ui/core';
import React from 'react';
import { FC } from 'react';
import MailIcon from '@material-ui/icons/Mail';
import { isExpectedShippingDateChangedFromNonNull } from './utils/shippingDateUtils';
import { useRequest } from '../common/useRequestHook';
import { RequestMethod } from '../utils/request';
import { useDispatch } from 'react-redux';
import { showNotification } from 'src/common/notifications/NotificationsActions';
import { NotificationVariant } from 'src/models/Notification';
import i18next from 'i18next';
import { useConfirmationDialog } from 'src/common/confirmationDialog/useConfirmationDialog';
import { loadOrderSuccess } from './OrderActions';
import { Order } from 'src/models/Order';

interface Props {
    mailing: string[] | undefined;
    history: any[];
    orderId: string;
}

export const ExpectedShippingDateChangeMail: FC<Props> = ({
    mailing,
    history,
    orderId
}) => {
    const dispatch = useDispatch();
    const confirm = useConfirmationDialog();
    const [sendExpectedShippingDateChangeEmail, { inProgress }] = useRequest<
        Order
    >(RequestMethod.POST, '/order/mail-expected-shipping-date-change');

    if (!isExpectedShippingDateChangedFromNonNull(history)) {
        return null;
    }

    const handleSendEmail = async (): Promise<void> => {
        if (!(await confirm(i18next.t('confirmShippingDateMail')))) {
            return;
        }
        const updatedOrder = await sendExpectedShippingDateChangeEmail({
            orderId
        });
        dispatch(loadOrderSuccess(updatedOrder));
        dispatch(
            showNotification({
                id: 'shipping_date_change_email',
                variant: NotificationVariant.Success,
                text: i18next.t('shippingDateMailSuccess')
            })
        );
    };

    return (
        <IconButton
            onClick={handleSendEmail}
            disabled={
                mailing?.includes('EXPECTED_SHIPPING_DATE_CHANGE') || inProgress
            }
        >
            <MailIcon />
        </IconButton>
    );
};
